import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';

import ModalBody from '../../atoms/ModalBody';
import ModalFooterCloseButtonComponent from '../../molecules/ModalFotterCloseButtonComponent';

class ContainsUsedVenueAlertModal extends React.Component {
  static get propTypes() {
    return {
      targetId: PropTypes.string,
      children: PropTypes.string,
      show: PropTypes.bool,
      onCloseButtonClick: PropTypes.func,
    };
  }

  render() {
    return (
      <Modal show={this.props.show}>
        <ModalBody>
          <p className="text-center">
            選択された会場の中にすでに使用済みの会場が含まれています
          </p>
        </ModalBody>
        <ModalFooterCloseButtonComponent
          onClick={this.props.onCloseButtonClick}
        />
      </Modal>
    );
  }
}

export default ContainsUsedVenueAlertModal;
